const filter = [
  {
    service: {
      folder: 'user',
      file: 'Users',
      relationship: ''
    },
    listLabel: 'name',
    label: 'Leitor',
    itemValue: 'id',
    itemText: 'name',
    id: 'user_id',
    query: {
      ativo: true
    }
  },
  {
    service: {
      folder: 'emprestimos',
      file: 'StatusEmprestimos',
      relationship: ''
    },
    listLabel: 'name',
    label: 'Status',
    itemValue: 'id',
    itemText: 'descricao',
    id: 'status_emprestimo_id'
  }
]

export default filter
